import axios from "axios";
import { WEBSERVER_URL } from "src/utils/constants";

const instance = axios.create({
  baseURL: WEBSERVER_URL,
});

export default instance;
